export const API_URL = process.env.REACT_APP_API_URL;
export const STORAGE = "hw-sentiment-analysis";
export const STORE_STORAGE = "hw-sentiment-analysis-store";
export const KEYS = {
    AUTH_ACCESS: "hwsa-auth-access",
    AUTH_REFRESH: "hwsa-auth-refresh",
}
export const PUSHER_CRED = {
    KEY: process.env.REACT_APP_PUSHER_KEY,
    CLUSTER: process.env.REACT_APP_PUSHER_CLUSTER,
}

export const URLS = {
    USER: {
        SIGNUP: '/signup',
        LOGIN: '/login',
        SSO_LOGIN: '/sso-login',
        FORGOT_PASSWORD: '/forgot-password',
        RESET_PASSWORD: '/reset-password/:token',
        PROFILE: '/profile',
        STORE_INFO: '/profile/store-info',
        PERSONAL_INFO: '/profile/personal-info',
    },
    DASHBOARD: '/sentiment-analysis',


    STORE: {
        BRANCHES: "/store/branches",
        CREATE: "/store/create",
        // UPDATE: "",
        LIST: "store/",
        ADD_BRANCH: '/store/branch/create',
    },
    WORD: '/words',
    REVIEW: '/reviews',
    TOPIC: '/topics',
    SETTINGS: '/settings',
    DATASOURCES: {
        CREATE: '/datasources/create',
        LIST: '/datasources',
    },
    RATING: '/ratings',
    ASSISTANT: {
        SEND: '/assistant',
    },

    RECOMMENDATION: {
        RECOMMENDATION_LIST: '/recomendation',
    },
    MODULE_SELECTION: '/module-selection',

}

export const APIS = {
    USER: {
        LOGIN: API_URL + '/auth/login',
        SSO_LOGIN: API_URL + '/auth/sso-login',
        USER_DETAILS: API_URL + '/auth/user-details',
        LOGOUT: API_URL + '/auth/logout',
        FORGOT_PASSWORD: API_URL + '/forgot/password',
        RESET_PASSWORD: API_URL + '/auth/reset-password',
        CHANGE_PASSWORD: API_URL + '/users/password',
        REGISTRATION: API_URL + '/users/register',
        PROFILE: API_URL + '/users/profile',
        UPDATE_USER: API_URL + '/user',
        STORE_INFO: '/profile/store-info',
        PERSONAL_INFO: '/profile/personal-info',
    },
    STORE: {
        GET_STORE: API_URL + '/stores/',
        ADD_STORE: API_URL + '/stores/',
        UPDATE_STORE: API_URL + '/stores/',
        BRANCH_LIST: API_URL + '/stores/',
        ADD_BRANCH: API_URL + '/stores/branches/',
        UPDATE_BRANCH: API_URL + '/stores/branches/',
        GET_STORE_TYPE: API_URL + '/stores/store-types/',
    },
    DATASOURCE: {
        GET_DATASOURCES: API_URL + '/datasource/',
        ADD_EXTERNAL_DATASOURCE: API_URL + '/datasource/add-external-source/',
        ADD_INTERNAL_DATASOURCE: API_URL + '/datasource/upload-csv/',
    },
    SENTIMENT: {
        GET_SENTIMENT_TIMELINE: API_URL + '/feedback/sentiment_counts',
        GET_SENTIMENT_BREAKDOWN: API_URL + '/feedback/sentiment_breakdown',
        GET_SENTIMENT_OVERALL: API_URL + '/feedback/sentiment_score',
        GET_SENTIMENT_COMPARISON: API_URL + '/feedback/sentiment/comparison',
        GET_REVIEW_VOLUMN: API_URL + '/feedback/review_count',
        GET_REVIEW_RATING: API_URL + '/feedback/rating_count',
    },
    TOPIC: {
        TOPIC_LIST: API_URL + '/feedback/topic_sentiment',
    },
    WORD: {
        WORD_LIST: API_URL + '/feedback/word_sentiment',
    },
    REVIEW: {
        GET_REVIEW_SUMMARY: API_URL + '/feedback/review_summary',
        REVIEW_LIST: API_URL + '/feedback/review_details',
    },
    RATING: {
        RATING_SUMMARY: API_URL + '/feedback/rating_details',
        OVERALL_RATING: API_URL + '/feedback/review_details',
    },
    ASSISTANT: {
        SEND: API_URL + '/chat/query',
    },
    CHAT_SESSIONS: {
        LIST:     API_URL + '/chat/sessions',
        CREATE:   API_URL + '/chat/sessions',
        DELETE:   (id: string) => `${API_URL}/chat/sessions/${id}`,
        MESSAGES: (id: string) => `${API_URL}/chat/sessions/${id}/messages`,
        QUERY:    (id: string) => `${API_URL}/chat/sessions/${id}/query`,
    },
    RECOMMENDATION: {
        RECOMMENDATION_LIST: API_URL + '/recommendation/recommendations_list',
    }
}

export const ACTIONS = {
    RESET_REDUCER: "ACTIONS/RESET_REDUCER",
    LOADER: {
        FP_STATUS: "ACTIONS/LOADER/FP_STATUS",
    },
    MENU: {
        TOGGLE: "ACTIONS/MENU/TOGGLE",
    },
    USER: {
        LOGIN: "ACTIONS/USER/LOGIN",
        SSO_LOGIN: "ACTIONS/USER/SSO_LOGIN",
        LOGOUT: "ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "ACTIONS/USER/RESET_PASSWORD",
        PASSWORD_RESET: "ACTIONS/USER/PASSWORD_RESET",
        SET_MODULES: "ACTIONS/USER/SET_MODULES",
        SET_COMPANY: "ACTIONS/USER/SET_COMPANY",
        STORE_INFO: '/profile/store-info',
        PERSONAL_INFO: '/profile/personal-info',
    },
    STORE: {
        GET_STORE: "ACTIONS/STORE/GET_STORE",
        GET_BRANCH: "ACTIONS/STORE/GET_BRANCH",
        REFRESH_BRANCHES: "ACTIONS/STORE/REFRESH_BRANCHES",
    },
    PUSHER: {
        ADD_DATA: "ADD_PUSHER_DATA",
        RESET_DATA: "RESET_PUSHER_DATA",
    },
    FILTER: {
        SET: "ACTIONS/FILTER/SET",
        CLEAR: "ACTIONS/FILTER/CLEAR",
    },
}

export const SAGA_ACTIONS = {
    USER: {
        LOGIN: "SAGA_ACTIONS/USER/LOGIN",
        SSO_LOGIN: "SAGA_ACTIONS/USER/SSO_LOGIN",
        LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "SAGA_ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
        REGISTER: "SAGA_ACTIONS/USER/REGISTER",
        PROFILE: "SAGA_ACTIONS/USER/PROFILE",
        UPDATE_USER: "SAGA_ACTIONS/USER/UPDATE_USER",
        GET_USER_DETAILS: "SAGA_ACTIONS/USER/GET_USER_DETAILS",
        STORE_INFO: '/profile/store-info',
        PERSONAL_INFO: '/profile/personal-info',
    },

    STORE: {
        GET_STORE: "ACTIONS/STORE/GET_STORE",
        ADD_STORE: "ACTIONS/STORE/ADD_STORE",
        UPDATE_STORE: "ACTIONS/STORE/UPDATE_STORE",
        BRANCH_LIST: "ACTIONS/STORE/BRANCH_LIST",
        ADD_BRANCH: "ACTIONS/STORE/ADD_BRANCH",
        UPDATE_BRANCH: "ACTIONS/STORE/UPDATE_BRANCH",
        GET_STORE_TYPE: "ACTIONS/STORE/GET_STORE_TYPE",
    },

    DATASOURCE: {
        GET_DATASOURCES: "ACTIONS/DATASOURCE/GET_DATASOURCES",
        ADD_EXTERNAL_DATASOURCE: "ACTIONS/DATASOURCE/ADD_EXTERNAL_DATASOURCE",
        ADD_INTERNAL_DATASOURCE: "ACTIONS/DATASOURCE/ADD_INTERNAL_DATASOURCE",
    },
    SENTIMENT: {
        GET_SENTIMENT_TIMELINE: "ACTIONS/SENTIMENT/GET_SENTIMENT_TIMELINE",
        GET_SENTIMENT_BREAKDOWN: "ACTIONS/SENTIMENT/GET_SENTIMENT_BREAKDOWN",
        GET_SENTIMENT_OVERALL: "ACTIONS/SENTIMENT/GET_SENTIMENT_OVERALL",
        GET_SENTIMENT_COMPARISON: "ACTIONS/SENTIMENT/GET_SENTIMENT_COMPARISON",
        GET_REVIEW_VOLUMN: "ACTIONS/SENTIMENT/GET_REVIEW_VOLUMN",
        GET_REVIEW_RATING: "ACTIONS/SENTIMENT/GET_REVIEW_RATING",
    },
    TOPIC: {
        TOPIC_LIST: "ACTIONS/SENTIMENT/TOPIC_LIST",
    },
    WORD: {
        WORD_LIST: "ACTIONS/SENTIMENT/WORD_LIST",
    },
    REVIEW: {
        GET_REVIEW_SUMMARY: "ACTIONS/SENTIMENT/GET_REVIEW_SUMMARY",
        REVIEW_LIST: "ACTIONS/SENTIMENT/REVIEW_LIST",
    },
    RATING: {
        RATING_SUMMARY: "ACTIONS/SENTIMENT/RATING_SUMMARY",
        OVERALL_RATING: "ACTIONS/SENTIMENT/OVERALL_RATING",
    },
    ASSISTANT: {
        SEND: "ACTIONS/SENTIMENT/ASSISTANT",
    },
    CHAT_SESSIONS: {
        GET:    "SAGA_ACTIONS/CHAT_SESSIONS/GET",
        CREATE: "SAGA_ACTIONS/CHAT_SESSIONS/CREATE",
        DELETE: "SAGA_ACTIONS/CHAT_SESSIONS/DELETE",
        MSGS:   "SAGA_ACTIONS/CHAT_SESSIONS/MESSAGES",
        QUERY:  "SAGA_ACTIONS/CHAT_SESSIONS/QUERY",
    },
    RECOMMENDATION: {
        RECOMMENDATION_LIST: "ACTIONS/SENTIMENT/RECOMMENDATION_LIST",
    }
}